import { render, staticRenderFns } from "./FilialMetric.vue?vue&type=template&id=fb6a74b2&scoped=true&"
import script from "./FilialMetric.vue?vue&type=script&lang=js&"
export * from "./FilialMetric.vue?vue&type=script&lang=js&"
import style0 from "./FilialMetric.vue?vue&type=style&index=0&id=fb6a74b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a74b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSheet,VTooltip})
